export const ALL_MANDATORY = 'Alla obligatoriska fält måste anges';
export const THIS_MANDATORY = 'Denna uppgift är obligatorisk att ange';